import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/header/u008.png'


const _withScopeId = n => (_pushScopeId("data-v-1457a4d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "customize-content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "品牌定制介绍：", -1))
const _hoisted_3 = { class: "customize" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "私有化部署：", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 将笔熊分享应用部署到您自己的服务器上。域名、品牌、logo、广告语您都可以自定义。私有化版本为企业定制化版本，供企业内部使用，部分功能有所差异。 ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "如需品牌定制或私有化部署请联系客服", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]

import { ref } from 'vue';
// 品牌定制介绍

export default /*#__PURE__*/_defineComponent({
  __name: 'Content',
  setup(__props) {

const customize = ref<string[]>([
  '可以为您自定义分享文档的标题后缀',
  '可以为您定制分享文档的专属广告语',
  '可以为您定制分享文档的logo'
]);

const toKf = () => {
  window.open('https://work.weixin.qq.com/kfid/kfc4a7552f98cdf9983', '_blank')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customize.value, (item, index) => {
        return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(item), 1))
      }), 128))
    ]),
    _hoisted_4,
    _hoisted_5,
    _createElementVNode("div", {
      class: "contact flex-a-center",
      onClick: toKf
    }, _hoisted_8)
  ]))
}
}

})